import {
	MENU_IS_ACTIVE,
	ACTIVE_MENU_ITEM,
	ACTIVE_MENU_ITEMS,
	SEARCH_IS_ACTIVE,
} from '../types';

export const toggleMenuActive = (isActive) => {
	return {
		type: MENU_IS_ACTIVE,
		isActive,
	};
};

export const setActiveMenuItems = (activeMenuItems = [], keepActive = false) => {
	return {
		type: ACTIVE_MENU_ITEMS,
		activeMenuItems,
		isActive: keepActive || (activeMenuItems && activeMenuItems.length > 0),
	};
};

export const setActiveMenuItem = (activeMenuItem, level = 0) => {
	return {
		type: ACTIVE_MENU_ITEM,
		activeMenuItem,
		level,
	};
};

export const toggleSearchActive = (isActive) => {
	return {
		type: SEARCH_IS_ACTIVE,
		isActive,
	};
};
